import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  Signal,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InfoButtonComponent } from '../info-button/info-button.component';
import { MODULES_CONTEXTUAL_INFO } from '@app/core/constants/modules';
import { AuthService } from '@app/core/services/auth/auth.service';
import { InfoMap, ModuleContextualInfo } from './types/section-title.types';

import { GenericApplicationSections } from '@shared/interfaces/agnostic-sections.type';
import { AgnosticSectionsTitles } from '@app/core/models/agnostic-sections-titles.model';
import { IconButtonComponent } from '../icon-button/icon-button.component';
@Component({
  selector: 'app-section-title',
  imports: [FontAwesomeModule, InfoButtonComponent, IconButtonComponent],
  templateUrl: './section-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionTitleComponent {
  private readonly _authService = inject(AuthService);

  public title = input<AgnosticSectionsTitles>();
  public section = input.required<GenericApplicationSections>();
  public description = input<string>();
  public modulesContextualInfo = input<ModuleContextualInfo>(
    MODULES_CONTEXTUAL_INFO,
  );
  public noteClick = output<void>();

  protected readonly isClerk = this._authService.isClerk;

  private readonly _fallbackInfoMap: InfoMap = {
    infoText: '',
    infoTitle: '',
  };

  protected readonly infoMap: Signal<InfoMap> = computed(() => {
    const section = this.section();
    const contextualInfo = this.modulesContextualInfo();
    if (!Object.hasOwn(contextualInfo, section)) {
      return this._fallbackInfoMap;
    }
    return {
      infoText: contextualInfo[section].info,
      infoTitle: contextualInfo[section].title,
    };
  });

  protected readonly showNoteButton: Signal<boolean> = computed(() => {
    if (!this.isClerk()) return false;
    const section = this.section();
    const contextualInfo = this.modulesContextualInfo();
    if (!Object.hasOwn(contextualInfo, section)) return false;

    return true;
  });
}
